<div class="row">
    <div class="col-xl-8 col-lg-7 col-md-6 col-sm-4 col-2">
        <p class="text-left view-label my-4">{{ viewLabel | translate }}</p>
    </div>
    <div *ngIf="showSyncProducts" class="col-xl-4 col-lg-5 col-md-6 col-sm-8 col-10 text-right my-auto">
        <button (click)="syncProducts()" class="btn green-btn">{{ "SYNC_PRODUCTS" | translate }}</button>
    </div>
</div>
